export var SendinblueAllowedExtensions;
(function (SendinblueAllowedExtensions) {
    SendinblueAllowedExtensions["PDF"] = "pdf";
    SendinblueAllowedExtensions["TXT"] = "txt";
    SendinblueAllowedExtensions["DOCX"] = "docx";
    SendinblueAllowedExtensions["PPTX"] = "pptx";
    SendinblueAllowedExtensions["XLSX"] = "xlsx";
    SendinblueAllowedExtensions["GIF"] = "gif";
    SendinblueAllowedExtensions["JPG"] = "jpg";
    SendinblueAllowedExtensions["JPEG"] = "jpeg";
    SendinblueAllowedExtensions["PNG"] = "png";
    SendinblueAllowedExtensions["TIF"] = "tif";
    SendinblueAllowedExtensions["TIFF"] = "tiff";
    SendinblueAllowedExtensions["BMP"] = "bmp";
    SendinblueAllowedExtensions["MP3"] = "mp3";
    SendinblueAllowedExtensions["M4A"] = "m4a";
    SendinblueAllowedExtensions["M4V"] = "m4v";
    SendinblueAllowedExtensions["WAV"] = "wav";
    SendinblueAllowedExtensions["MP4"] = "mp4";
    SendinblueAllowedExtensions["MOV"] = "mov";
    SendinblueAllowedExtensions["AVI"] = "avi";
})(SendinblueAllowedExtensions || (SendinblueAllowedExtensions = {}));
export var EmailType;
(function (EmailType) {
    EmailType["VisitorDailyEmail"] = "VisitorDailyEmail";
    EmailType["VisitorMonthlyEmail"] = "VisitorMonthlyEmail";
    EmailType["VisitorWeeklyEmail"] = "VisitorWeeklyEmail";
})(EmailType || (EmailType = {}));
export var EmailDeliveryStatus;
(function (EmailDeliveryStatus) {
    EmailDeliveryStatus["AwaitingInsert"] = "AwaitingInsert";
    EmailDeliveryStatus["Inserting"] = "Inserting";
    EmailDeliveryStatus["Processing"] = "Processing";
    EmailDeliveryStatus["Completed"] = "Completed";
    EmailDeliveryStatus["Failed"] = "Failed";
    EmailDeliveryStatus["Draft"] = "Draft";
    EmailDeliveryStatus["Pending"] = "Pending";
})(EmailDeliveryStatus || (EmailDeliveryStatus = {}));
export var ContactCommunicationType;
(function (ContactCommunicationType) {
    ContactCommunicationType["OneToOne"] = "OneToOne";
    ContactCommunicationType["Bulk"] = "Bulk";
    ContactCommunicationType["Automated"] = "Automated";
})(ContactCommunicationType || (ContactCommunicationType = {}));
